import { SchoolSportSeason } from '@maxpreps/apiserviceclients/apiModels';

const getIsPublishedSportSeason = (
  sportSeasonId: string,
  teamSeasonPickerData: SchoolSportSeason[]
) =>
  teamSeasonPickerData?.find(ss => ss.sportSeasonId == sportSeasonId)
    ?.isPublished ?? false;

export default getIsPublishedSportSeason;
